export default __webpack_public_path__ + "static/media/cerebellum_mask.43c7312b.png";